// its middlewear to handle reducer call to update a state
const menuStatus = (value) => ({
    type: 'MENU_STATUS',
    payload: value
});
export { menuStatus }